module.exports = __webpack_public_path__ + "img/formBanner_m.32800ea9.jpg";